export default {
  leads: [],
  atrasadas: [],
  venceAmanha: [],
  venceHoje: []
}
